import { render, staticRenderFns } from "./AbrFormProp.vue?vue&type=template&id=c4c96f86"
import script from "./AbrFormProp.vue?vue&type=script&lang=js"
export * from "./AbrFormProp.vue?vue&type=script&lang=js"
import style0 from "./AbrFormProp.vue?vue&type=style&index=0&id=c4c96f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports